import {
  expaGetClientSideExpaFromCookie,
  expaGetClientSideFrozenExpaFromCookie,
  expaSetClientSideFrozenExpaCookie,
} from '../../expa'
import { experimentsAlgoliaCompeteraExperimentIsEnabledAndV1 } from '../../experiments/algolia-competera-experiment/experimentsAlgoliaCompeteraExperiment'
import { type ExperimentType } from '../../experiments/model/Experiment.types'

export const cartIntermediateFreezeExpaCookie = (
  experiments: ExperimentType[],
): void => {
  const expaCookie = expaGetClientSideExpaFromCookie()
  const frozenExpa = expaGetClientSideFrozenExpaFromCookie()
  let expaToSet = ''
  if (
    !expaCookie &&
    experimentsAlgoliaCompeteraExperimentIsEnabledAndV1(experiments)
  ) {
    expaToSet = 'tsta'
  } else if (expaCookie && !frozenExpa) {
    expaToSet = expaCookie
  }

  expaSetClientSideFrozenExpaCookie(expaToSet)
}
